<template>
  <div class="home">
    <Header></Header>
    <router-view class="main" />
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/layouts/appHeader'
import Footer from '@/layouts/appFooter'
import { getBrowser } from '@/utils'
export default {
  name: 'home',
  components: {
    Header,
    Footer
  },
  created () {
    if (getBrowser() === 'ie') {
      // window.addEventListener('hashchange', () => {
      //   if (this.$route.name === 'index') {
      //     window.location.reload()
      //   } else if (this.$route.name === 'campdetail') {
      //     window.location.reload()
      //   }
      // })
    }
  }
}
</script>
<style lang="scss">
.home {
  height: 100%;
  padding-top: 60px;
  .main {
    height: 100%;
    width: 1180px;
    margin: 0 auto;
  }
}
</style>
